export default __webpack_public_path__ + "i18n/translations/translation-ta.6a35ca3b.json";